exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading[data-v-ebb564d4]{display:none;font-size:14px;margin-top:50px;margin-bottom:40px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.heading span[data-v-ebb564d4]{display:inline-block;width:14.28571%;text-align:center;text-transform:capitalize}.heading span.diametro[data-v-ebb564d4],.heading span.peso[data-v-ebb564d4]{width:8.33333%}", ""]);

// exports
